var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');

var Contains = Object.create(Model);

Contains.name = 'Contains';
Contains['@class'] = 'Contains';
Contains.url = 'contains';

Contains.fields = {
  out: {
    validators : {
      presence: true
    }
  },
  in: {
    validators: {
      presence: true
    }
  },
  name: {
    default: null,
    validators : {
      presence : true,
      length: {minimum: 3, maximum: 128, default: ''}, 
    }
  },
  index: {}
};

module.exports = Contains;
